export default {
  setAll(state, static_translations) {
    state.all = static_translations
  },
}
